(function() {

  var VISITED_PAGE_STATUS = 'visited_page';

  zfrespond.models.ExposedContactCampaign = Backbone.Model.extend({
    
    markPageVisited: function() {
      this.save({
        response_status: VISITED_PAGE_STATUS
      }, {patch: true})
    },
    
  	url: function(){
      var url = '/v2/respond/contact_campaigns';
      if (this.get('obfuscated_id')){
        url += '/' + this.get('obfuscated_id');
      }
  	  return url;
  	}

  });
 
}());